import React from 'react';

type StaticImageLike = string | { src: string };

type AppImageProps = Omit<
  React.ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'width' | 'height'
> & {
  src: StaticImageLike;
  alt: string;
  width?: number | string;
  height?: number | string;
  fill?: boolean;
  priority?: boolean;
  quality?: number;
  sizes?: string;
  unoptimized?: boolean;
};

const resolveSrc = (src: StaticImageLike) =>
  typeof src === 'string' ? src : (src?.src ?? '');

const Image = React.forwardRef<HTMLImageElement, AppImageProps>(
  ({ src, alt, width, height, fill, style, ...rest }, ref) => {
    const resolvedSrc = resolveSrc(src);

    return (
      <img
        ref={ref}
        src={resolvedSrc}
        alt={alt}
        width={fill ? undefined : width}
        height={fill ? undefined : height}
        crossOrigin="anonymous"
        style={
          fill
            ? {
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                ...style,
              }
            : style
        }
        {...rest}
      />
    );
  },
);

Image.displayName = 'Image';

export default Image;
